import { isEmpty, isEqual, xorWith } from 'lodash';

/**
 * Sorts an array of objects alphabetically using an object key
 * @param a
 * @param b
 * @param key
 */
export const sortByKeyAlphabetic = <T>(a: T, b: T, key: keyof T) => {
  if (a[key] && b[key]) {
    return String(a[key]).toLowerCase() > String(b[key]).toLowerCase() ? 1 : -1;
  }

  return -1;
};

export const isArrayEqual = (x: any, y: any) => isEmpty(xorWith(x, y, isEqual));
